import React from 'react';
import HeaderSeven from '../../components/Header/HeaderFive';
import Footer from '../../components/Footer/FooterThree';
import VideoPage from './VideoPage';

const SkillLab = () => {
  return (
    <>
      <HeaderSeven />
      <VideoPage />
      <Footer />
    </>
  );
};

export default SkillLab
;
